// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.object-summary-summary {
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  column-gap: 30px;
  padding: 20px 30px;
  border-bottom: 1px solid #D3E1ED;
}
.object-summary-summary .object-summary-summary-title {
  color: #6A8991;
  font-size: 13px;
  font-weight: 500;
}
.object-summary-summary .object-summary-summary-value {
  margin-top: 6px;
  color: #142A31;
  font-size: 14px;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/ObjectSummaryRow/ObjectSummaryRow.scss"],"names":[],"mappings":"AAAA;EACC,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EAEA,gCAAA;AAAD;AAEC;EACC,cAAA;EACA,eAAA;EACA,gBAAA;AAAF;AAGC;EACC,eAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AADF","sourcesContent":[".object-summary-summary {\n\tbackground-color: #FFFFFF;\n\tdisplay: flex;\n\talign-items: center;\n\tcolumn-gap: 30px;\n\tpadding: 20px 30px;\n\n\tborder-bottom: 1px solid #D3E1ED;\n\n\t.object-summary-summary-title {\n\t\tcolor: #6A8991;\n\t\tfont-size: 13px;\n\t\tfont-weight: 500;\n\t}\n\n\t.object-summary-summary-value {\n\t\tmargin-top: 6px;\n\t\tcolor: #142A31;\n\t\tfont-size: 14px;\n\t\tfont-weight: bold;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
